// sislav-01 — integração Sislav (lavanderia)
const catalogo: Record<string, string> = {
    "100 = lavagem grátis": "100 = lavado gratis",
    "Chave da API Sislav": "Clave de la API Sislav",
    "Configure a Sislav: pontos nas lavagens e secagens, troca de pontos por lavagem com desconto e uso como recompensa do Clube.": "Configura Sislav: puntos en lavados y secados, canje de puntos por lavado con descuento y uso como recompensa del Club.",
    "Desconto na lavanderia (%)": "Descuento en la lavandería (%)",
    "ID da unidade na Sislav": "ID de la unidad en Sislav",
    "Integração Sislav (lavanderia)": "Integración Sislav (lavandería)",
    "Na Sislav, cadastre o webhook com a URL https://sales-api.pontuax.com.br/v1/webhooks/sislav e os eventos Venda aprovada e Cliente cadastrado": "En Sislav, registra el webhook con la URL https://sales-api.pontuax.com.br/v1/webhooks/sislav y los eventos Venta aprobada y Cliente registrado",
    "Sislav (lavanderia)": "Sislav (lavandería)",
    "Token do webhook": "Token del webhook",
    "Vale em lavadora": "Vale en lavadora",
    "Vale em secadora": "Vale en secadora",
};

export default catalogo;
